import { axiosInstance } from 'src/util/axios.js'

const useApiKeysApi = () => {
  const getTokens = async () => {
    try {
      const response = await axiosInstance.post('/core/external/getApiKeys', {
        limit: 10,
        offset: 0,
      })
      return response.data.data.sort((a: any, b: any) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      })
    } catch (err) {
      console.error('Get Api Keys error', err)
    }
  }

  const revokeToken = async (id: number) => {
    try {
      return await axiosInstance.post('/core/external/disableApiKey', {
        id,
      })
    } catch (err) {
      console.error('Revoke token error', err)
    }
  }

  return { getTokens, revokeToken }
}

export default useApiKeysApi
